module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-28@2x-0357eacb598b65423eb870af402b4b8f.png";